import { DEFAULT_COLOR as e } from "../../constants/default-styles.mjs";
import { useTranslation as t } from "../../i18n.mjs";
import { isImageSelected as n } from "../image-extension/utils/is-image-selected.mjs";
import { ColorPicker as r } from "../../components/color-picker/index.mjs";
import { ColorSwatchIcon as i } from "../../components/content-controls/color-swatch-icon.mjs";
import { useEditorState as a } from "@tiptap/react";
import { useMemo as o } from "react";
import { jsx as s } from "react/jsx-runtime";
import { normalizeToHex as c } from "@systemeio/util";
import { PaletteIcon as l } from "@systemeio/icons";
//#region src/extensions/text-color-extension/use-text-color-extension-toolbar.tsx
var u = (u, d) => {
	let { t: f } = t(), { shouldHideTooltip: p, showAlpha: m = !0 } = d ?? {}, h = a({
		editor: u,
		selector: ({ editor: e }) => ({
			isEditable: e?.options.editable ?? !1,
			isImageSelected: n(e),
			textColor: e?.getAttributes("textStyle").color
		})
	}), g = h?.textColor, _ = g ? c(g) : e, v = !h?.isEditable || !!h?.isImageSelected;
	return o(() => {
		let e = (e) => /* @__PURE__ */ s(r, {
			applyLabel: f("global.apply"),
			clearDisabled: !g,
			clearLabel: f("global.clear"),
			color: _,
			disabled: v,
			label: f("font_color"),
			onApply: (e) => u?.chain().focus().setColor(e).run(),
			onClear: () => u?.chain().focus().unsetColor().run(),
			onPreview: (e) => u?.chain().setColor(e).run(),
			showAlpha: m,
			asSheetRow: e,
			showTooltip: !p,
			children: /* @__PURE__ */ s(i, {
				color: g ? _ : void 0,
				children: /* @__PURE__ */ s(l, {})
			})
		});
		return {
			toolbarRender: e(!1),
			sheetRender: e(!0)
		};
	}, [
		_,
		u,
		g,
		v,
		p,
		m,
		f
	]);
};
//#endregion
export { u as useTextColorExtensionToolbar };
